<template>
  <div class="dashboard-container">
    <div class="dashboard-container" v-if="showwt===''">
      <span class="showcon" @click="show('user')">用户反馈</span>
      <div class="showcon" >
        <a href="/uaa/admin/test/list/download">测听反馈</a>
      </div>
    </div>
    <div class="useradvicemain" v-if="showwt==='user'">
      <div class="back">
        <span @click="back()">返回</span>
      </div>
      <div class="advicemain" v-if="useradvicelist.length>0">
        <div class="advicelist" v-for="item in useradvicelist">
          <div class="advicelisttitle">
            <span>{{item.username}}</span>
            <span>{{formDate(item.createTime)}}</span>
          </div>
          <div class="advicelistcontnet">
            {{item.comment}}
          </div>
        </div>
      </div>
      <div class="advicemain" v-else>
       <div class="noadvice">
         暂无反馈信息
       </div>
      </div>
      <div class="pagecontent con" v-if="useradvicelist.length>0">
        <div class="conbetween">
          <div class="checkcon">
            <pagination
              v-show="advicetotal>0"
              :total="advicetotal"
              :page.sync="advicelistQuery.page"
              :limit.sync="advicelistQuery.limit"
              @pagination="getadvicelist"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getuseradvicelist, getuserhearlist } from '@/services/userinfo'
import Pagination from '@/components/Page/pagination'
export default {
  components: {
    pagination: Pagination
  },
  name: 'Dashboard',
  data () {
    return {
      currentRole: 'adminDashboard',
      height: '',
      showwt: '',
      useradvicelist: [],
      userhearlist: [],
      advicetotal: 0,
      advicelistQuery: {
        page: 1,
        limit: 10
      },
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      }
    }
  },
  mounted () {
    this.getadvicelist()
    this.gethearlist()
  },
  methods: {
    async getadvicelist () {
      let data = {
        page: this.advicelistQuery.page - 1,
        size: this.advicelistQuery.limit
      }
      let response = await getuseradvicelist(data)
      let data1 = [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ]
      this.useradvicelist = response.data.content
      // this.useradvicelist = data1
      this.advicetotal = response.data.totalElements
    },
    async gethearlist () {
      let data = {
        page: this.listQuery.page - 1,
        size: this.listQuery.limit
      }
      let response = await getuserhearlist(data)
      this.userhearlist = response.data.content
      this.total = response.data.totalElements
    },
    back () {
      this.showwt = ''
    },
    show (val) {
      this.showwt = val
      if (val === 'user') {
        this.advicelistQuery.page = 1
        this.getadvicelist()
      }
      if (val === 'hear') {
        this.listQuery.page = 1
        this.gethearlist()
      }
    },
    async  getload () {
      let response = await getuserhearlist()
    },
    formDate (dateForm) {
      if (dateForm === '' || dateForm === null || dateForm === undefined) { // 解决deteForm为空传1970-01-01 00:00:00
        return ''
      } else {
        var dateee = new Date(dateForm).toJSON()
        var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
        return date
      }
    }
  }
}
</script>
<style lang="less" scoped>
.dashboard-container {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .showcon {
    width: 30%;
    height: 100px;
    margin: 30px;
    text-align: center;
    background: #fff;
    line-height: 100px;
    a{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .useradvicemain {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: scroll;
     .back {
      width: 98%;
      padding: 20px;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      border-bottom: 1px solid #ececec
    }
    .advicemain{
       width: 98%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      .advicelist{
        display: flex;
        flex-direction: column;
        padding: 20px;
        margin-top: 5px;
        background: #fff;
        .advicelisttitle{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          span{
            padding: 10px 0
          }
          span:nth-child(2){

          }
        }
        .advicelistcontnet{

        }
      }
      .advicelist:nth-child(1){
        margin: 0
      }
      .noadvice{

      }
    }
    .pagecontent {
      border-top: 1px solid #ececec;
      width: 98%;
      background: #fff;
      margin-bottom: 20px;
      .checkcon {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding: 20px;
      }
    }
  }
  .userhearmain {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .back {
      width: 98%;
      padding: 20px;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: #fff;
    }
    .tablecontent {
      width: 98%;
      padding: 0 20px 20px 20px;
      background: #fff;
      .table-top {
        width: 100%;
        color: #666666;
        font-weight: 600;
      }
      .table-main {
        width: 100%;
        padding-top: 20px;
      }
    }
   .pagecontent {
      width: 98%;
      background: #fff;
      margin-bottom: 20px;
      .checkcon {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue